import React from "react";
import { Avatar, CardHeader, Chip, Tooltip } from "@material-ui/core";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { i18n } from "../../translate/i18n";

const statusConfig = {
	open:    { label: "Em Atendimento", color: "#2D7BE8", bg: "rgba(45,123,232,0.1)" },
	pending: { label: "Pendente",       color: "#f59e0b", bg: "rgba(245,158,11,0.1)" },
	closed:  { label: "Resolvido",      color: "#16a34a", bg: "rgba(22,163,74,0.1)"  },
};

const TicketInfo = ({ contact, ticket, onClick }) => {
	const attendant = ticket.user;
	const queue     = ticket.queue;
	const status    = statusConfig[ticket.status] || null;

	const contactName =
		document.body.offsetWidth < 600 && contact.name?.length > 10
			? contact.name.substring(0, 10) + "…"
			: contact.name;

	const userName = attendant
		? (document.body.offsetWidth < 600
			? attendant.name
			: `${i18n.t("messagesList.header.assignedTo")} ${attendant.name}`)
		: null;

	return (
		<CardHeader
			onClick={onClick}
			style={{ cursor: "pointer", padding: "8px 16px", flex: 1, minWidth: 0 }}
			titleTypographyProps={{ noWrap: true, variant: "body1" }}
			subheaderTypographyProps={{ noWrap: true, variant: "body2" }}
			avatar={
				<Tooltip title="Ver informações do contato" placement="bottom">
					<div style={{ position: "relative", display: "inline-flex" }}>
						<Avatar
							src={contact.profilePicUrl}
							alt="contact_image"
							style={{ width: 42, height: 42 }}
						>
							{contact.name?.charAt(0).toUpperCase()}
						</Avatar>
						<InfoOutlinedIcon
							style={{
								position: "absolute",
								bottom: -2,
								right: -2,
								fontSize: 14,
								color: "#fff",
								backgroundColor: "#2D7BE8",
								borderRadius: "50%",
								padding: 1,
							}}
						/>
					</div>
				</Tooltip>
			}
			title={
				<span style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 4 }}>
					<span style={{ fontWeight: 600 }}>{contactName}</span>

					{/* Status do ticket */}
					{status && (
						<Chip
							label={status.label}
							size="small"
							style={{
								height: 18,
								fontSize: "0.62rem",
								borderRadius: 9,
								backgroundColor: status.bg,
								color: status.color,
								fontWeight: 700,
								border: `1px solid ${status.color}33`,
							}}
						/>
					)}

					{/* Conexão WhatsApp */}
					{ticket.whatsapp?.name && (
						<Chip
							icon={<WhatsAppIcon style={{ fontSize: 11, color: "#25D366" }} />}
							label={ticket.whatsapp.name}
							size="small"
							variant="outlined"
							style={{
								height: 18,
								fontSize: "0.62rem",
								borderRadius: 9,
								borderColor: "#25D366",
								color: "inherit",
							}}
						/>
					)}

					{/* Fila */}
					{queue?.name && (
						<Chip
							label={queue.name}
							size="small"
							style={{
								height: 18,
								fontSize: "0.62rem",
								borderRadius: 9,
								backgroundColor: queue.color ? `${queue.color}22` : "rgba(0,0,0,0.06)",
								color: queue.color || "inherit",
								border: `1px solid ${queue.color ? `${queue.color}55` : "rgba(0,0,0,0.12)"}`,
								fontWeight: 600,
							}}
						/>
					)}
				</span>
			}
			subheader={userName}
		/>
	);
};

export default TicketInfo;
